import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useOperatorTasks } from '@/entities/OperatorTask/model/store';
import { useAdminAccess, canAccessPermission } from '@/shared/model/adminAccess';
import { RequestStatus } from '@/shared/model/requestStatus';
import { ActionButton } from '@/shared/ui/ActionButton/ActionButton';
import { formatMoscowDateTime } from '@/shared/lib/dateTime';
import { useCurrentTime } from '@/shared/hooks/useCurrentTime';
import { useTaskNotificationPolling } from '../model/useTaskNotificationPolling';
import { TaskNotifications } from './TaskNotifications';
import classes from './OperatorTaskWorkspaceHeader.module.scss';

/** Показывает московское время и доступ к общей очереди */
export const OperatorTaskWorkspaceHeader = () => {
    const location = useLocation();
    const allowed = useAdminAccess((state) => canAccessPermission(state.snapshot, 'admin.operator-tasks.view'));
    const summary = useOperatorTasks((state) => state.summary);
    const status = useOperatorTasks((state) => state.summaryStatus);
    const offset = useOperatorTasks((state) => state.clockOffset);
    const updatedAt = useOperatorTasks((state) => state.summaryUpdatedAt);
    const open = useOperatorTasks((state) => state.notificationsOpen);
    const openNotifications = useOperatorTasks((state) => state.openNotifications);
    const closeNotifications = useOperatorTasks((state) => state.closeNotifications);
    const reset = useOperatorTasks((state) => state.reset);
    const now = useCurrentTime(offset);
    const refresh = useTaskNotificationPolling(allowed);

    useEffect(() => {
        if (!allowed) reset();
        return reset;
    }, [allowed, reset]);

    useEffect(() => { closeNotifications(); }, [location.key, closeNotifications]);

    return (
        <>
            <div className={classes.header}>
                <div className={classes.clock}>
                    <time
                        dateTime={new Date(now).toISOString()}
                        title={updatedAt
                            ? 'Время синхронизировано с сервером'
                            : 'Текущее время по часам устройства'
                        }
                    >
                        {formatMoscowDateTime(new Date(now).toISOString())}
                    </time>
                    {allowed && status === RequestStatus.Error && (
                        <small role="status">
                            Нет связи с задачником
                        </small>
                    )}
                </div>
                {allowed && (
                    <ActionButton
                        icon="pi pi-bell"
                        iconOnly
                        size="small"
                        outlined
                        className={classes.bell}
                        aria-label={status === RequestStatus.Error
                            ? 'Задачи: сводка недоступна'
                            : `Задачи требуют внимания: ${summary?.attentionCount ?? 'загрузка'}`
                        }
                        title="Общая очередь задач"
                        badge={status === RequestStatus.Error
                            ? '!'
                            : summary?.attentionCount
                                ? summary.attentionCount > 99
                                    ? '99+'
                                    : String(summary.attentionCount)
                                : undefined
                        }
                        badgeClassName="p-badge-danger"
                        aria-haspopup="dialog"
                        aria-expanded={open}
                        aria-controls="task-notifications-panel"
                        onClick={() => {
                            if (open) closeNotifications();
                            else {
                                openNotifications();
                                refresh();
                            }
                        }}
                    />
                )}
            </div>
            {allowed &&
                <TaskNotifications />
            }
        </>
    );
};
